export default __webpack_public_path__ + "static/media/package-1.0f781704.svg";